import styled from 'styled-components';

export const StyledMarkDown = styled.div`
  &.markdown-text * {
    font-family: inherit;
    color: inherit;
    margin: 0px;
  }
`;
